<template>
  <el-dialog @close="$emit('update:visible',false)" v-bind="$attrs" :title="isEdit ? '编辑数据' : '添加一条数据'" class="dialog-1400" width="1200px">
    <el-form ref="form" :model="form" label-width="150px" v-loading="loading" :rules="RnterpriseFromRules">

      <el-tabs v-model="active">
        <el-tab-pane label="单位基本信息" name="0">
          <el-form-item label="单位名称" prop="companyName">
            <el-input v-model="form.companyName" :maxlength="255" style="width:406px;" placeholder="请输入单位名称"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <el-input v-model="form.creditCode" :maxlength="255" style="width:406px;" placeholder="请输入统一社会信用代码"></el-input>
          </el-form-item>

          <el-form-item label="单位性质" prop="unitProperties">
            <el-select v-model="form.unitProperties" placeholder="请选择单位性质">
              <el-option v-for="item in [{value:1,label:'请选择单位性质'}]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成立时间" prop="establishmentDate">
            <el-date-picker v-model="form.establishmentDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="注册资金" prop="registeredCapital">
            <el-input v-model.number="form.registeredCapital" :maxlength="9" style="width:193px;" placeholder="请输入注册金额">
              <span slot="suffix">万元</span>
            </el-input>
          </el-form-item>
          <el-form-item label="单位电话" prop="workTelephone">
            <el-input v-model="form.workTelephone" :maxlength="12" style="width:193px;" placeholder="请输入电话号码"></el-input>
          </el-form-item>
          <el-form-item label="邮编" prop="postalCode">
            <el-input v-model="form.postalCode" :maxlength="9" style="width:193px;" placeholder="请输入邮编号码"></el-input>
          </el-form-item>

          <el-form-item label="近年三年年度营业额" prop="yearTurnover" >
            <el-input style="width:195px;float: left;"  :maxlength="9" v-model.number="yearTurnover[0]" placeholder="2022">
              <span slot="suffix">万元</span>
            </el-input>
            <!-- <el-form-item  label-width="0" style="float: left;margin-left: 20px;"> -->
              <el-input style="width:195px;margin-left: 15px;" :maxlength="9" v-model.number="yearTurnover[1]" placeholder="2021">
                <span slot="suffix">万元</span>
              </el-input>
            <!-- </el-form-item> -->
            <!-- <el-form-item  label-width="0" style="float: left;margin-left: 20px;"> -->
              <el-input style="width:195px;margin-left: 15px;" :maxlength="9" v-model.number="yearTurnover[2]" placeholder="2020">
                <span slot="suffix">万元</span>
              </el-input>
            <!-- </el-form-item> -->
            <!-- <el-input style="width:169px;margin-left: 20px;margin-right: 10px;" type="number" v-model="yearTurnover[1]" placeholder="2021"></el-input>万元
            <el-input style="width:169px;margin-left: 20px;margin-right: 10px;" type="number" v-model="yearTurnover[2]" placeholder="2020"></el-input>万元 -->
          </el-form-item>
          <el-form-item label="职工总数" prop="workforce">
            <el-input style="width:195px;float: left;" :maxlength="9" v-model.number="form.workforce" placeholder="职工总数">
              <span slot="suffix">人</span>
            </el-input>
            <el-form-item label="高级职称" prop="seniorProf" label-width="120px" style="float: left;margin-left: 20px;">
              <el-input style="width:180px;" :maxlength="9" v-model.number="form.seniorProf" placeholder="高级职称">
                <span slot="suffix">人</span>
              </el-input>
            </el-form-item>
            <el-form-item label="中级职称" prop="middleProf" label-width="120px" style="float: left;margin-left: 20px;">
              <el-input style="width:180px;" :maxlength="9" v-model.number="form.middleProf" placeholder="中级职称">
                <span slot="suffix">人</span>
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="具有职业资格" prop="profQual" >
            <el-input style="width:195px;float: left;" :maxlength="9" v-model.number="form.profQual" placeholder="请输入">
              <span slot="suffix">人</span>
            </el-input>
            <el-form-item label="研究生及以上" prop="postgraduateAbove" label-width="120px" style="float: left;margin-left: 20px;">
              <el-input style="width:180px;" :maxlength="9" v-model.number="form.postgraduateAbove" placeholder="请输入">
                <span slot="suffix">人</span>
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="规划资质等级" prop="planQualLevel" >
            <el-select v-model="form.planQualLevel" placeholder="请选择资质等级" style="width:195px;float: left;">
              <el-option v-for="item in [{value:1,label:'请选择资质等级'}]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-form-item label="资质证号" label-position="right" prop="qualCertNo" label-width="120px" style="float: left;margin-left: 20px;">
              <el-input style="width:180px;" :maxlength="255" v-model="form.qualCertNo" placeholder="请输入资质编号"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="业务范围" prop="businessScope" >
            <el-input type="textarea" v-model="form.businessScope" :rows="4"  placeholder="多行输入"></el-input>
          </el-form-item>

        </el-tab-pane>
        <el-tab-pane label="单位法人信息" name="1">
          <el-form-item label="单位法人" prop="unitLegalPerson">
            <el-input v-model="form.unitLegalPerson" :maxlength="255" style="width:406px;" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactNumber">
            <el-input v-model="form.contactNumber" :maxlength="12" style="width:406px;" placeholder="请输入电话号码"></el-input>
          </el-form-item>
          <el-form-item label="职务 / 职称" prop="jobTitle">
            <el-input v-model="form.jobTitle" style="width:406px;" :maxlength="255" placeholder="请输入职务职称"></el-input>
          </el-form-item>
          <el-form-item label="单位代表" prop="unitRepresentative">
            <el-input v-model="form.unitRepresentative" style="width:406px;" :maxlength="255" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="idNumber">
            <el-input v-model="form.idNumber" style="width:406px;" :maxlength="18" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="政治面貌" prop="politicalOutlook">
            <el-select style="width:193px;float: left;" v-model="form.politicalOutlook" placeholder="请选择政治面貌">
              <el-option v-for="item in politicalOutlookList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <!-- <el-input v-model="form.politicalOutlook" style="width:406px;" placeholder="请输入"></el-input> -->
          </el-form-item>
          <el-form-item label="邮箱" prop="mailbox">
            <el-input v-model="form.mailbox" style="width:406px;" :maxlength="255" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="微信号" prop="wxCode">
            <el-input v-model="form.wxCode" style="width:406px;" :maxlength="30" placeholder="请输入微信号"></el-input>
          </el-form-item>
          <el-form-item label="qq号码" prop="qqCode">
            <el-input v-model="form.qqCode" style="width:406px;" :maxlength="19" placeholder="请输入qq号码"></el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="附件" name="2">
          <el-form-item label="申请注册承诺书" label-width="160px" prop="promise">
            <UploadFile v-model="form.promise" fileType="promise" />
          </el-form-item>
          <el-form-item label="营业执照复印件" label-width="160px" prop="businessLicense">
            <UploadFile v-model="form.businessLicense" fileType="businessLicense" />
          </el-form-item>
          <el-form-item label="单位资质证书复印件" label-width="160px" prop="unitCert">
            <UploadFile v-model="form.unitCert" fileType="unitCert" />
          </el-form-item>
          <el-form-item label="企业logo" label-width="160px" prop="unitLogo">
            <UploadFile v-model="form.unitLogo" fileType="unitLogo" list-type="picture" accept=".jpg,.jpeg,.png" />
          </el-form-item>
          <el-form-item label="单位简介(word格式)" label-width="160px" prop="unitProfile">
            <UploadFile v-model="form.unitProfile" fileType="unitProfile" accept=".docx,.doc"/>
          </el-form-item>
          <div class="explain">附注：此表格一式两份，请填写加盖公章后同单位简介（word格式）、单位营业执照复印件、单位资质证书复印件、企业logo一并上传至本网站</div>
        </el-tab-pane>
      </el-tabs>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible',false)">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
import { update as updateApi } from "@/api/enterpriseMember.js";
import EditDialog from "../mixins/EditDialog.js";
import { RnterpriseFrom } from "@/utils/rules.js";
import { politicalOutlookList } from "@/utils/index.js";

export default {
  mixins: [EditDialog],
  components: { UploadFile },
  data() {
    return {
      politicalOutlookList,
      // 由于RnterpriseFrom使用到的了yearTurnover属性，这里需要更改this的指向
      RnterpriseFromRules: RnterpriseFrom.apply(this),
      yearTurnover: [],
      updateApi,
      active: "0",
    };
  },
  // computed:{
  //   yearTurnover:{
  //     get(){
  //       if(!this.form.yearTurnover) return []
  //       return this.form.yearTurnover.split(';')
  //     },
  //     set(v){
  //       this.form.yearTurnover = v.join(";");
  //     }
  //   }
  // },
  watch:{
    form: {
      handler(v) {
        this.yearTurnover = v.yearTurnover.split(';')
      },
      deep: true,
    },
    yearTurnover:{
      handler(){
        this.form.yearTurnover = this.yearTurnover.join(";");
      },
      deep:true
    }
  },
  methods:{
    onSubmit(){
      // 验证表单
      this.$refs["form"].validate((valid, key) => {
        if (valid) {
          this.form.yearTurnover = this.yearTurnover.join(";");
          // 调用mixins的添加方法
          this.submit()
        } else {
          let errKey = Object.values(key)[0][0];
          let field = errKey.field;
          this.$message.warning(errKey.message);
          // 跳转到对应的tab
          if (["username", "password",'accountType','memberType'].indexOf(field) != -1) {
            this.active = '-1';
          } else if (
            [
              "creditCode",
              "unitProperties",
              "companyName",
              "registeredCapital",
              "establishmentDate",
              "workTelephone",
              "postalCode",
              "yearTurnover",
              "yearTurnover1",
              "yearTurnover2",
              "yearTurnover3",
              "workforce",
              "seniorProf",
              "middleProf",
              "profQual",
              "postgraduateAbove",
              "planQualLevel",
              "businessScope",
              "qualCertNo",
              "businessScope",
            ].indexOf(field) != -1
          ) {
            this.active = '0';
          } else if (
            [
              "unitLegalPerson",
              "contactNumber",
              "jobTitle",
              "unitRepresentative",
              "idNumber",
              "politicalOutlook",
              "mailbox",
              "wxCode",
              "qqCode",
            ].indexOf(field) != -1
          ) {
            this.active = '1';
          } else {
            this.active = '2';
          }
          return false;
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
</style>